module.exports = __webpack_public_path__ + "static/media/дыхание-здоровья.a1c6b9e9.jpg";